module.exports = __webpack_public_path__ + "static/fourth_user_image3-6dbc62aeda15c5b62b707acfcf2907db.jpg";